export default "__VITE_ASSET__X6qEa5Cb__"